import {
    AddToEmailFlowModal,
    BulkDeleteCustomersModal,
    BulkGrantAffiliateModal,
    BulkGrantProductModal,
    BulkTaggingModal,
    ExportCsvModal,
} from './modals';
import { MODAL_TYPES, type ModalType } from '../constants/customers.constants';

interface CustomerModalsProps {
    activeModal: ModalType;
    onClose: () => void;
    totalCustomers: number;
    totalPages: number;
    filterArray: string | undefined;
    onDeleteSuccess?: () => void;
}

export function CustomerModals({
    activeModal,
    onClose,
    totalCustomers,
    totalPages,
    filterArray,
    onDeleteSuccess,
}: CustomerModalsProps) {
    return (
        <>
            <BulkTaggingModal
                isOpen={activeModal === MODAL_TYPES.ADD_TAG}
                onClose={onClose}
                mode='add'
                totalCustomers={totalCustomers}
                filterArray={filterArray}
            />

            <BulkTaggingModal
                isOpen={activeModal === MODAL_TYPES.REMOVE_TAG}
                onClose={onClose}
                mode='remove'
                totalCustomers={totalCustomers}
                filterArray={filterArray}
            />

            <BulkGrantProductModal
                isOpen={activeModal === MODAL_TYPES.GRANT_PRODUCT}
                onClose={onClose}
                totalCustomers={totalCustomers}
                filterArray={filterArray}
            />

            <BulkGrantAffiliateModal
                isOpen={activeModal === MODAL_TYPES.GRANT_AFFILIATE}
                onClose={onClose}
                totalCustomers={totalCustomers}
                filterArray={filterArray}
            />

            <AddToEmailFlowModal
                isOpen={activeModal === MODAL_TYPES.ADD_TO_FLOW}
                onClose={onClose}
                totalCustomers={totalCustomers}
                filterArray={filterArray}
            />

            <BulkDeleteCustomersModal
                isOpen={activeModal === MODAL_TYPES.DELETE_CUSTOMERS}
                onClose={onClose}
                totalCustomers={totalCustomers}
                filterArray={filterArray}
                onDeleteSuccess={onDeleteSuccess}
            />

            <ExportCsvModal
                isOpen={activeModal === MODAL_TYPES.EXPORT_CSV}
                onClose={onClose}
                totalCustomers={totalCustomers}
                totalPages={totalPages}
                filterArray={filterArray}
            />
        </>
    );
}
